import styled from "styled-components";
export const StyledDiv = styled.div`
    background:rgba(209, 245, 255, 0.5);
    width: 100%;
    padding: 2rem 0rem 2rem 0vw;
    .container-with-dots {
      margin-top: 20px;
      padding-bottom: 10px;
    }
    .image-item {
      padding: 10px;
    }
  `,
  BoldText = styled.h1`
    font-size: 18px;
    font-weight: 600;
    padding: 0rem;
    color: #083f88;
    text-align: center;
    @media only screen and (min-width: 600px) {
      font-size: 20px;
    }
    @media only screen and (min-width: 725px) {
      font-size: 24px;
    }
    @media only screen and (min-width: 1000px) {
      font-size: 2.4vw;
    }
  `,
  SupportBox = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;
    width: 100%;
    padding: 0rem 0rem 1rem 0rem;
    height: 100%;
    overflow: hidden;
    @media only screen and (min-width: 600px) {
      height: 18.5rem;
      flex-direction: row;
      justify-content: center;
      align-items: center;
    }
    @media only screen and (min-width: 725px) {
      height: 20rem;
    }
    @media only screen and (min-width: 1000px) {
      height: 28vw;
    }
  `,
  Header = styled.div`
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
  `;
